import React, { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import UsersSummary from "../components/information_cards/usersSummary";
import UsersTable from "../components/applications/table/usersTable";
import DescriptionCard from "../components/userdetailscard";
import Footer from "../components/Navbars/footer";

function AdminSettings() {
  const { auth } = useAuth();

  return (
    <>
      <div className="w-full max-w-[95%] 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
        <div className="">
          <UsersSummary />
        </div>

        <main className="">
          <div className="flex space-x-4">
            <UsersTable />
          </div>
        </main>
        <div className="">
          <DescriptionCard />
        </div>
        {/* <Footer /> */}
      </div>
    </>
  );
}

export default AdminSettings;
